import * as types from '../../types'
import {
    API_URL
} from '../../utils/constants'
import {
    displayMessages,
    setSavingState
} from '../Layout/actions'
import {
    createAxiosInstance,
    validateModel
} from '../../utils/helpers'
import {
    tableActions
} from '@mawesi-sas/mws_react_component_table';
import FileDownload from 'react-file-download';

export function reiniciarEstado() {
    const axios = createAxiosInstance()
    return (dispatch) => {
        const modelo = 'Solicitud'
        const column = 'nombre_cafeteria'
        const filters = []

        axios.post(`${API_URL}/list/values`, {
                modelo,
                filters,
                column,
                orderBy: {
                    field: 'nombre_cafeteria',
                    direction: 'asc'
                }
            })
            .then((res) => {
                const list = res.data.map(x => {
                    return {
                        caption: x,
                        value: x
                    }
                })
                dispatch({
                    type: types.REPORTE2_REINICIAR_ESTADO
                })
                dispatch({
                    type: 'HYQ3_MODIFY_INPUT_VALUE',
                    payload: {
                        reducer: 'reporte2',
                        path: 'cafeterias',
                        value: list
                    }
                })
            })
            .catch((err) => {
                console.log(err)
                displayMessages(dispatch, err)
            })
    }
}

export function getDataFromServer(page = 1, excel = false) {
    const axios = createAxiosInstance()
    return (dispatch, getState) => {
        const modelo = 'Solicitud'
        const include = ['solicitante', 'detalles', 'distribuciones.cenco.aprobador']
        const take = 100
        const cafeteria = getState().reporte2.getIn(['cafeteria']) || false
        const filter = getState().reporte2.getIn(['filter'])
        const fields = ['id', 'evento_actividad', 'nombre_cafeteria', 'fecha_hora', 'lugar', 'estado', 'solicitante.name', 'distribuciones.cenco.codigo']
        const filters = [{
            group: {
                id: 0,
                glue: 'and'
            },
            field: 'nombre_cafeteria',
            operator: '=',
            value: cafeteria,
            andOr: 'and'
        }]

        if (!cafeteria) {
            displayMessages(dispatch, {
                success: 'Seleccione una cafetería para consultar la informacion'
            })
            return
        }

        if (filter) {
            fields.forEach(x => {
                let f = {
                    group: {
                        id: 1,
                        glue: 'and'
                    },
                    field: x,
                    operator: 'like',
                    value: filter
                }
                filters.push(f)
            })
        }
        const skip = (page - 1) * take
        const data = {
            modelo,
            filters,
            include,
            skip,
            take,
            orderBy: {
                field: 'id',
                direction: 'desc'
            },
            total: true,
            excel
        }

        if (excel) {
            axios.post(`${API_URL}/reportes/solicitudes-cafeteria`, data, {
                    responseType: 'arraybuffer'
                })
                .then((res) => {
                    FileDownload(res.data, 'Solicitudes por cafetería.xlsx');
                })
                .catch((err) => {
                    let obj
                    if (err.response && err.response.data) {
                        const {
                            data,
                            status
                        } = err.response;
                        const decodedString = JSON.parse(String.fromCharCode.apply(null, new Uint8Array(data)));
                        obj = {
                            response: {
                                data: decodedString,
                                status
                            }
                        };
                    } else {
                        obj = err
                    }
                    console.log(err)
                    displayMessages(dispatch, obj);
                })
        } else {
            axios.post(`${API_URL}/reportes/solicitudes-cafeteria`, data)
                .then((res) => {
                    const list = res.data.data.map(x => {
                        x._enabled = true
                        return x
                    })
                    const records = res.data.total
                    dispatch(tableActions.mswTable_mostrarDatos('reporte2', 'reporte2', list, page, records))
                })
                .catch((err) => {
                    console.log(err)
                    displayMessages(dispatch, err)
                })
        }
    }
}